import * as S from './styles.ts';
import { ColorKey } from '@template/theme/types/color.type.ts';
import { ReactNode } from 'react';

export interface IIconHolderProps {
  children: ReactNode;
  color: ColorKey;
}

const IconHolder = ({ children, color = 'primary' }: IIconHolderProps) => {
  return <S.IconHolderWrapper $color={color}>{children}</S.IconHolderWrapper>;
};

export default IconHolder;
